import abi from "./Transactions.json";
/*
An Application Binary Interface (ABI) is intended to serve 
as the de facto method for encoding & decoding data into & 
out of transactions.
ABI is the compiled version of an API (or as an API on the 
low level).
*/
export const contractABI = abi.abi;
export const contractAddress = "0xBBfC98F87E32A63266ce9811bB7337e2109E8086";
